$(document).ready(function() {
  
  if($(window).width() >= 1024){
     $('.homepage-row .grid__item').matchHeight({
       byRow: false
     });
     $('.tea-shoppe-row .post-large--one-half').matchHeight({
       byRow: false
     });
  }


  
    $('.homepage-featured-grid').owlCarousel({
   items: 4,
    nav:false,
    dots:true,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true,
            dots:true
        },
        768:{
            items:4,
            nav:false,
            dots:true
        }
    }
});
  var fps = $('#featured-products-section');
  $('.products-mini__tabs-nav-item').each(function(index) {
    $(this).on("click", function() {
      var activeTab = index+1;
      $(this).closest('ul').find('.active-tab').removeClass('active-tab');
      $(this).addClass('active-tab');
      fps.find('.active').removeClass('active');
      $('.homepage-featured-grid').eq(index).addClass('active');
    });
    
  });
  
}); //end ready